import { Address, InternalOperationProductionOrder } from './order'

export interface ProductionOrder {
  id: string
  productionOrderId: string
  salesOrderId: string
  channel: string
  brand: string
  locale: string
  promisedCampaign: string
  plant: string
  virtualPlant: string
  shipments: Shipment[]
  approvedForProductionDate: Date
  status: string
  timestamp: Date
  createdAt: Date
  eventSortKey: string
  correlationId: string
  redo: Redo
}

export interface Redo {
  code: string
  reason: string
  reasonText: string
}

export interface Shipment {
  // add this fields when needed
  deliveryAddress: Address
  //pickupPointAddress: PickupPointAddress
  //billingAddress: BillingAddress
  deliveryType: string
  deliveryMethod: string
  products: string[]
  productsData: ProductionOrderProduct[]
  customerPromiseDate: string
  shipmentCostCurrency: string
  shipmentCostIncludingTax: number
  shipmentCostExcludingTax: number
}

export interface ProductionOrderProduct {
  id: string
  quantity: number
  articleCode: string
  productOptionsList: ProductionOrderProductOption[]
  resourceFiles: ProductionOrderResourceFile[]
  salesPriceCurrency: string
  unitSalesPriceIncludingTax: number
  unitSalesPriceExcludingTax: number
}

export interface ProductionOrderResourceFile {
  resourceFileId: string
  fileType: string
  resourceType: string
}

export interface ProductionOrderProductOption {
  key: string
  value: string
}

export enum ProductionOrderStatus {
  Unknown = 0,
  New = 1,
  Accepted = 2,
  WaitingForProduction = 3,
  InProduction = 4,
  Delayed = 5,
  Packed = 6,
  PartiallyShipped = 7,
  ScannedForShipment = 8,
  Cancelled = 9,
  Failed = 10,
  Split = 11
}

export interface RedoProductionOrdersRequest {
  orderCode: string
  productionOrders: InternalOperationProductionOrder[]
  deliveryAddress: RedoDeliveryAddress
  pickupPointData?: RedoPickupPointData
  deliveryMethod: string
  deliveryType: string
  customerMustReceiveBy: string
  reasonPhrase: string
  reasonCode: string
  comment: string
}

export interface RedoDeliveryAddress {
  customerTitle?: string
  customerFirstName?: string
  customerPrefix?: string
  customerLastName?: string
  addressLine1: string
  addressLine2?: string
  city: string
  countryId: string
  zipCode: string
  companyName?: string
  customerPhone?: string
  customerEmail?: string
}

export interface RedoPickupPointData {
  pickupPointExternalIdentifier: string
  pickupPointName: string
}

export interface ProductionOrderDeliveryAddress {
  companyName?: string
  addressLine1: string
  addressLine2?: string
  city: string
  countryId: string
  zipCode: string
  customerTitle?: string
  customerFirstName: string
  customerPrefix?: string
  customerLastName: string
  customerEmail: string
  customerPhone: string
}
